import apiClient from '../apiClient';
import { POST_BALANCE_DETAIL_URL } from '../apiUrl';

const postBalanceDetailApi = data => {
  return apiClient.post(POST_BALANCE_DETAIL_URL, data);
};

export default postBalanceDetailApi;
